import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import { PostStudyLogError, PostStudyLogRequest, PostStudyLogResponse } from '@/api/model';

const KEY = {
  POST_STUDY_LOG: 'POST_STUDY_LOG',
} as const;

const request = {
  postStudyLog: async ({ payload, studyId }: PostStudyLogRequest) => {
    const { data } = await fetchClient.APPS.post<PostStudyLogResponse>(
      `${ENDPOINTS.APPS.STUDY}${studyId}/log`,
      { body: { body: payload.body } },
    );

    return data;
  },
};

const mutation = {
  usePostStudyLog: () =>
    useMutation<PostStudyLogResponse, PostStudyLogError, PostStudyLogRequest>({
      mutationFn: request.postStudyLog,
    }),
};

export const studyLog = {
  KEY,
  mutation,
  request,
};
